import { render } from "./List.vue?vue&type=template&id=7febf24d"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7febf24d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7febf24d', __exports__)) {
    api.reload('7febf24d', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=7febf24d", () => {
    api.rerender('7febf24d', render)
  })

}


export default __exports__